/* import __COLOCATED_TEMPLATE__ from './procedure-list-item-stats.hbs'; */
/* RESPONSIBLE TEAM: team-actions */

import Component from '@glimmer/component';

interface ProcedureListItemStatsSignature {
  Args: {
    procedureId: string;
  };
  Element: HTMLDivElement;
}

// Mapping of stat types to their corresponding metric IDs
const STAT_TO_METRIC_ID: Record<string, string> = {
  triggered: 'fin.conversations_participated.count',
  resolved: 'fin.resolution_rate',
  handoff: 'fin.procedure_handoff_rate',
  escalated: 'fin.routed_to_team_rate',
};

export default class TasksProcedureListItemStats extends Component<ProcedureListItemStatsSignature> {
  get chartDefinitions(): Record<string, any> {
    return {
      triggered: this.chartDefinitionForStat('triggered'),
      resolved: this.chartDefinitionForStat('resolved'),
      handoff: this.chartDefinitionForStat('handoff'),
      escalated: this.chartDefinitionForStat('escalated'),
    };
  }

  private chartDefinitionForStat(stat: string): any {
    let procedureId = this.args.procedureId;
    let metricId = STAT_TO_METRIC_ID[stat];

    if (!metricId) {
      throw new Error(`Invalid stat: ${stat}`);
    }

    return {
      id: `procedure_${procedureId}_${stat}`,
      visualization_type: 'counter',
      chart_series: [
        {
          metric_id: metricId,
          filters: {
            type: 'and',
            filters: [
              {
                type: 'category',
                data: {
                  property: 'fin.procedures_triggered.procedure_ids',
                  values: [procedureId],
                },
              },
            ],
          },
        },
      ],
    };
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Tasks::ProcedureListItemStats': typeof TasksProcedureListItemStats;
  }
}
